import '@/styles/global.css';

import { Toaster } from '@crehana/compass.ui/v3/toaster';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useLocation, useParams } from '@/shared/modern-router';
import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';
import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';
import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

const App = () => {
  const { slug } = useParams();
  const { pathname } = useLocation();

  const isUsersLayout = pathname.includes('/admin/company/users');

  return (
    <div className="tw-cds-root">
      <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
        <NuqsAdapter>
          <Outlet />
          {!isUsersLayout && <HanaFloatingChatLazy />}
        </NuqsAdapter>
        <AddBaseFunctionality />
        <Toaster />
      </SPALayout>
    </div>
  );
};

export default App;
